<div class="section border-bottom">
    <div class="video flex-1 d-flex p-1">

        <key-feed type="log"
            originType="asset"
            [clientId]="entity.owner.id"
            [id]="entity.id"
            [poll]="false"
            [limit]="101"
            [showDetailsModal]="false"
            [settings]="handler.settings"></key-feed>

    </div>
</div>